import { decimalIn } from 'Helpers/currencyFormat';
import { formatFigure, ZERO_DASH } from 'Helpers/formatService';

/**
 * Format a numeric summary cell: blank for null/undefined, the zero dash for zero
 * values. `absolute` exposes expenditure magnitudes as positive.
 *
 * An organisation can span currencies, so a per-project row formats in that
 * project's own locale (sent alongside the row). Aggregate rows pass no locale
 * and fall back to the page's conventions — and where the selection mixes
 * currencies, the caller suppresses the aggregate rather than showing a sum of
 * different units.
 *
 * @param {number|null|undefined} value
 * @param {boolean} absolute
 * @param {string|null} locale
 * @returns {string}
 */
export function formatCell(value, absolute = false, locale = null) {
    const resolved = absolute && value !== null && value !== undefined ? Math.abs(value) : value;

    return formatFigure(resolved, (figure) => (figure >= 0 ? decimalIn(locale, figure, 0) : `(${decimalIn(locale, Math.abs(figure), 0)})`));
}

/** A formatted cell carrying no figure, which must not take a gain/loss colour. */
export const isEmptyCell = (formatted) => formatted === '' || formatted === ZERO_DASH;
